"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlaceholderImage = PlaceholderImage;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _utils = require("../../utils");
var _moment = _interopRequireDefault(require("moment"));
var _Cloud = _interopRequireDefault(require("@material-ui/icons/Cloud"));
var _Icons = require("../Icons");
var _AttachmentIcon = _interopRequireDefault(require("../AttachmentIcon"));
var _excluded = ["src"],
  _excluded2 = ["attachment", "src", "loading", "fromMe", "style"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function formatDate(date) {
  var mailMomentDate = _moment["default"].unix(date);
  return mailMomentDate.format(!mailMomentDate.isSame(new Date(), 'year') ? 'MM/DD/YY' : mailMomentDate.isSame(new Date(), 'day') ? 'h:mm A' : 'MMM D');
}
function PlaceholderImage(_ref) {
  var defaultSrc = _ref.src,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    src = _useState2[0],
    setSrc = _useState2[1];
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  (0, _react.useEffect)(function () {
    var image = new Image();
    image.onload = function () {
      return setSrc(defaultSrc);
    };
    image.onerror = function () {
      return setSrc(t('placeholder-photo.png'));
    };
    image.src = defaultSrc;
  }, [defaultSrc]);
  if (!src) return null;
  return /*#__PURE__*/_react["default"].createElement("img", (0, _extends2["default"])({}, rest, {
    src: src
  }));
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.forwardRef)(function (_ref2, ref) {
  var _ref2$attachment = _ref2.attachment,
    attachment = _ref2$attachment === void 0 ? {} : _ref2$attachment,
    src = _ref2.src,
    _ref2$loading = _ref2.loading,
    loading = _ref2$loading === void 0 ? false : _ref2$loading,
    _ref2$fromMe = _ref2.fromMe,
    fromMe = _ref2$fromMe === void 0 ? false : _ref2$fromMe,
    style = _ref2.style,
    rest = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  var id = attachment.id,
    name = attachment.name,
    contentType = attachment.contentType,
    date = attachment.date,
    extendInfo = attachment.extendInfo,
    password = attachment.password;
  var iconType = id ? (0, _utils.getAttachmentType)(contentType, name) : null;
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: "shadow-lg w-full h-full inline-flex flex-col select-none bg-card cursor-pointer relative"
  }, rest, {
    ref: ref
  }), password !== undefined ? /*#__PURE__*/_react["default"].createElement(password ? _Icons.CloudLock : _Cloud["default"], {
    className: 'absolute right-0 top-0 mr-4 mt-4 text-gray-light'
  }) : null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center justify-center flex-1 overflow-hidden"
  }, src ? /*#__PURE__*/_react["default"].createElement(PlaceholderImage, {
    key: src,
    src: src,
    alt: name,
    className: "w-full h-full object-cover"
  }) : loading ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "skeleton bg-secondary w-full h-full"
  }) : iconType ? /*#__PURE__*/_react["default"].createElement(_AttachmentIcon["default"], {
    colored: true,
    contentType: contentType || 'others',
    fileName: name,
    className: "!text-4xl"
  }) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "skeleton bg-secondary w-full h-full"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "p-2 text-center"
  }, name ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "font-semibold text-xs truncate text-gray-dark",
    title: name
  }, name) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-4 skeleton bg-secondary w-40 inline-block"
  }), extendInfo && extendInfo.from && extendInfo.from.length ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-xs truncate",
    title: extendInfo.from[0].email
  }, fromMe ? 'From: Me' : extendInfo.from[0].name ? "From: ".concat(extendInfo.from[0].name) : extendInfo.from[0].email) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-4 skeleton bg-secondary w-30 inline-block"
  }), date ? /*#__PURE__*/_react["default"].createElement("div", {
    className: " text-xs truncate",
    title: _moment["default"].unix(date).format('ddd, MMM D, YYYY, h:mm A')
  }, formatDate(date)) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-4 skeleton bg-secondary w-20 inline-block"
  })));
});
//# sourceMappingURL=Item.js.map